
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/p/[slug]/[companyType]",
      function () {
        return require("private-next-pages/p/[slug]/[companyType].tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/p/[slug]/[companyType]"])
      });
    }
  